import { useTranslate } from "../../../../language/i18n";
import MessageBox, { Type } from "../../../shared/MessageBox/MessageBox";

type Props = {
  customCssClass?: string;
};

const OrderBlockedMessage = ({ customCssClass }: Props) => {
  const translate = useTranslate();

  return <MessageBox type={Type.Error} message={translate("ORDER_BLOCKED_BY_GROUP")} customCssClass={customCssClass} />;
};

export default OrderBlockedMessage;
